export class ClassCodigoDescripcionSelector {
  public CodigoNameColumn!: string;
  public DescripcionNameColumn!: string;
  public ValueNameColumn!: string;
  public WidhtCodigoDescripcion: number = 500;
  public MoreColumns!: string[];
  public AllDataSource!: any;
}
